import { render, staticRenderFns } from "./DmsUsersPermissions.vue?vue&type=template&id=6d88903f"
import script from "./DmsUsersPermissions.vue?vue&type=script&lang=js"
export * from "./DmsUsersPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports